import { render, staticRenderFns } from "./AssetReviewStepAttributes.vue?vue&type=template&id=1e154a7a&"
import script from "./AssetReviewStepAttributes.vue?vue&type=script&lang=js&"
export * from "./AssetReviewStepAttributes.vue?vue&type=script&lang=js&"
import style0 from "./AssetReviewStepAttributes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e154a7a')) {
      api.createRecord('1e154a7a', component.options)
    } else {
      api.reload('1e154a7a', component.options)
    }
    module.hot.accept("./AssetReviewStepAttributes.vue?vue&type=template&id=1e154a7a&", function () {
      api.rerender('1e154a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/AssetReview/ReviewSteps/AssetReviewStepAttributes.vue"
export default component.exports